export default __webpack_public_path__ + "assets/images/8374c0d5c7c7ffc4fbdcca85bc94a24b.png";